// Shared invalidation without coupling analytics transport to React's gates.
const listeners = new Set();
export function onAuthorizationContextChange(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
export function publishAuthorizationContext(access) {
    for (const listener of listeners) listener(access);
}
